import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const useFetch = (url, params) => {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const load = useCallback(() => {
    if (!url) return;
    api.get(url, { params: JSON.parse(key) }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [url, key]);
  useEffect(() => { load(); }, [load]);
  return { data, reload: load, setData };
};

export const fmtDate = (d) => {
  if (!d) return "—";
  const s = String(d).slice(0, 10).split("-");
  return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : d;
};

export const openPdf = async (url, filename) => {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
};

export const BRL = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const thisMonth = () => new Date().toISOString().slice(0, 7);
